var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view--wallpaper-categories"},[_c('wallpaper-categories-list',{attrs:{"show-filters":{ 'search': true },"show-paging":true,"show-sort":true}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bdc3f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/wallpapers/categories/Index.vue
// module id = PRex
// module chunks = 0